/*=========================================================================================
  File Name: moduleCourseClassActions.js
  Description: CourseClass Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    debugger
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/AddCourseClass", item)
        .then((response) => {
          debugger
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeCourseClassEvaluationMean(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CourseClass/DeleteCourseClassEvaluationMeans?ID=" + item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetClassNoCode(){
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCodeOfClassNo")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetAll")
        .then((response) => {
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetPracticalCourseClasses({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetPracticalCourseClasses")
        .then((response) => {

          commit('SET_PracticalCourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByInstructorID({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByInstructor")
        .then((response) => {
          commit('SET_CourseClass', response.data)
          debugger
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetNotEndCourseClassByInstructorID({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetNotEndCourseClassByInstructor")
        .then((response) => {
          commit('SET_CourseClass', response.data)
          debugger
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseClassByTraineeID({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByTraineeID")
        .then((response) => {
          commit('SET_CourseClass', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByTraineeIDForAdmin({ commit },ID) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByTraineeIDForAdmin?ID="+ID)
        .then((response) => {
          commit('SET_CourseClass', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByInstructorAndTrainee({ commit },ID) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByInstructorAndTrainee?ID="+ID)
        .then((response) => {
          commit('SET_CourseClass', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByTraineeIDForTrainee({ commit },ID) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByTraineeIDForTrainee")
        .then((response) => {
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SearchCourseClassForRoom({ commit },search) {

    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/SearchCourseClassForRoom",search)
        .then((response) => {
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByDateForInstructor({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/GetCourseClassByDateForInstructor?date="+date)
        .then((response) => {
          commit('SET_CourseClass', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseClassByDate({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/GetCourseClassByDate?date="+date)
        .then((response) => {
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetSessionByCourseClassIDAndDate({ commit },data) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetSessionByCourseClassIDAndDate?courseClassID="+data.courseClassID+"&date="+data.date)
        .then((response) => {
          commit('SET_courseClassSession', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetSessionByCourseClassID({ commit },data) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetSessionByCourseClassID?courseClassID="+data.courseClassID)
        .then((response) => {
          commit('SET_courseClassSession', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  updateItem({ commit }, item) {


    return new Promise((resolve, reject) => {

      axios.put("api/CourseClass/UpdateCourseClass?ID="+item.ID, item)
        .then((response) => {
          debugger
          commit('UPDATE_CourseClass', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  ConfirmEvent({ commit }, item) {
    commit('UPDATE_CourseClass', item)
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/ConfirmCourseClass?annualPlanID="+item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID( { commit },itemid) {
    return new Promise((resolve, reject) => {

      axios.get("api/CourseClass/GetCourseClass?ID="+ itemid)
        .then((response) => {
           commit('SET_CourseClassModel', response.data)
         resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CourseClass/DeleteCourseClass?ID="+item)
        .then((response) => {
          commit('REMOVE_ITEM', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeSession(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CourseClass/DeleteCourseClassSession?ID="+item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addSession( item) {

    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/AddCourseClassSession"+item)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeInstructor(context,item) {

    return new Promise((resolve, reject) => {
      axios.delete("api/CourseClass/DeleteCourseClassInstructor?ID="+item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  InstructorConfirmation(context,ID)
  {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/InstructorConfirmation?courseClassID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  InstructorReject(context,ID)
  {
    debugger
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/InstructorReject?courseClassID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByIDWithTrainee(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByIDWithTrainee?ID="+ itemid)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseClassByCodeWithTrainee(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByCodeWithTrainee?ID="+ itemid)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  ConfirmRegistration(context, reg) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/ConfirmRegistration", reg)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SearchCourseClass({ commit },search) {

    return new Promise((resolve, reject) => {
      axios.post("api/CourseClass/SearchCourseClass",search)
        .then((response) => {
          debugger
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getUpComingTwoWeeksCourseClass({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/getUpComingTwoWeeksCourseClass")
        .then((response) => {
          debugger
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getCourseClassForDisplayName({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/getCourseClassForDisplayName")
        .then((response) => {
          debugger
          commit('SET_CourseClass', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetRoomPlanInPeriod({ commit },period) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetRoomPlanInPeriod?startDate="+period.start+"&endDate="+period.end)
        .then((response) => {
          commit('SET_CourseClass', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
